<template>
  <div>

    <div class="toggle-block__type-item popular-style" v-if="!isAdminManage && !isUserHasEasyOrder">
      <RadioLabelPicture
          name="shippingPartner"
          :label="$t('fbm_popularMethods.localization_value.value')"
          :value="FBM.data.popularMethodsType"
          @change="$emit('changePopularMethodsType', true)"
      >
      </RadioLabelPicture>
    </div>

    <div class="toggle-block__type-item"
         v-for="(item, index) in shippingCompanyData"
         :key="index"
    >
      <RadioLabelPicture
          name="shippingPartner"
          :label="item.name"
          :value="!FBM.data.popularMethodsType && FBM.data.shippingPartnerType.delivery_company_id === item.delivery_company_id"
          @change="$emit('changeShippingPartnerType', item)"
      >
        <template slot="ico">
          <img v-if="item.logo_base64" height="12" :src="item.logo_base64" alt="ico">
          <img v-else-if="item.logo" height="12" :src="item.logo" alt="ico">
        </template>
      </RadioLabelPicture>
    </div>
  </div>
</template>

<script>
import RadioLabelPicture from "@/components/UI/radiobuttons/RadioLabelPicture/RadioLabelPicture";

export default {
  name: "ShippingCompany",
  components: {RadioLabelPicture},

  props: {
    shippingCompanyData: Array,
    FBM: Object,
    isAdminManage: Boolean,
  },

  methods: {

  }

}
</script>

<style scoped>

.popular-style >>> .radio-label-picture__txt {
  font-weight: bold;
  color: #8f7a61;
}

.popular-style >>> .radio-label-picture__bg {
  border: 1px solid #f9e3ca;
}

</style>